import { CATALOGUE_FEATURE_KEY } from '@domgen/dgx-fe-catalogue';
import { CMS_FEATURE_KEY } from '@domgen/dgx-fe-cms';
import { COMMON_FEATURE_KEY, ResetActionConfig } from '@domgen/dgx-fe-common';
import { checkoutFailure } from '../+state/checkout.actions';
import { isCriticalCheckoutError } from '../utils/checkout-error/checkout-error.utils';

export const CHECKOUT_CRITICAL_ERROR_RESET_ACTION_CONFIG: ResetActionConfig<
  typeof checkoutFailure
> = {
  action: checkoutFailure,
  evaluation: (action: { error: Error }) =>
    isCriticalCheckoutError(action.error),
  persistedFeatureKeys: [
    CATALOGUE_FEATURE_KEY,
    CMS_FEATURE_KEY,
    COMMON_FEATURE_KEY,
  ],
};
